import isNumber from "lodash/isNumber";
/*
 * This code was copied over from the Mono Repo Common-Library
 * TODO: When the Common-Library gets exported to npm,
 * - Remove this file
 * - Update components to use npm package instead of this file
 *
 */
export const removeNonNumericCharacters = (str: string) =>
  str.replace(/[^0-9.]+/g, "");

const splitIntoWholeAndFractional = (numericValue: string) => {
  const numberParts = {
    whole: 0,
    fractional: 0,
  };
  const [whole, fractional] = numericValue.split(".");
  if (whole) {
    numberParts.whole = Number(whole);
  }
  if (fractional) {
    numberParts.fractional = parseFloat(`.${fractional}`);
  }

  return numberParts;
};

export const isLessThan = (maximum: string, target: string) => {
  const { whole: wholeMax, fractional: fractionalMax } =
    splitIntoWholeAndFractional(maximum);
  const { whole: wholeTarget, fractional: fractionalTarget } =
    splitIntoWholeAndFractional(target);
  return (
    wholeTarget < wholeMax ||
    (wholeTarget === wholeMax && fractionalTarget < fractionalMax)
  );
};

export const numberFromDisplay = (currency: string) => {
  return Number(removeNonNumericCharacters(currency));
};

// Format Number string
export const displayWithCommas = (amount: string, decimalPlaces = 2) => {
  if (amount === ".") {
    return "0.";
  }

  const justNumeric = removeNonNumericCharacters(amount);
  if (justNumeric === "") {
    return "";
  }

  const [wholePart, fractionalPart] = justNumeric.split(".");

  const formattedWhole = Intl.NumberFormat("en-US", {
    style: "decimal",
  }).format(numberFromDisplay(wholePart));

  if (fractionalPart === undefined) {
    return formattedWhole;
  }

  const formattedDecimal = fractionalPart.substring(0, decimalPlaces);

  return `${formattedWhole}.${
    fractionalPart.length > 0 ? formattedDecimal : ""
  }`;
};

export const formatNumber = (value: number, fractionDigits = 2) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
};

export const numberToDollars = (
  value: number,
  locale = { region: "en-US", currency: "USD" },
  fractionDigits: number = 2
): string => {
  const formatter = new Intl.NumberFormat(locale.region, {
    style: "currency",
    currency: locale.currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  return formatter.format(value);
};

export const formatSummaryValues = (value?: number) =>
  isNumber(value) ? numberToDollars(value) : "Unavailable";

export const ONLY_NUMBERS_AND_LETTERS_REGEX = /[^a-zA-Z0-9]/gi;
export const formatAccountNumber = (accountNumber: string): string => {
  return accountNumber
    .trim()
    .replace(ONLY_NUMBERS_AND_LETTERS_REGEX, "")
    .toUpperCase();
};
